// File for logic corresponding to browse page components
import './browse.scss';

function toggleFacets() {
  const facetToggles = document.querySelectorAll('.facet-toggle');

  if (! facetToggles.length) {
    return;
  }

  facetToggles.forEach((toggle) => {
    const titleEl = toggle.parentNode;
    const facetWrapper = titleEl.parentNode;

    toggle.addEventListener('click', () => {
      const ariaExpanded = 'true' === toggle.getAttribute('aria-expanded')
        ? 'false' : 'true';
      toggle.setAttribute('aria-expanded', ariaExpanded);
      facetWrapper.classList.toggle('isVisible');
    });
  });
}

function showMoreFacets() {
  const moreToggles = document.querySelectorAll('.facet-items-more--toggle');

  if (! moreToggles.length) {
    return;
  }

  moreToggles.forEach((toggle) => {
    const items = toggle.previousElementSibling;
    toggle.addEventListener('click', () => {
      toggle.classList.toggle('isVisible');
      items.classList.toggle('isVisible');
    });
  });
}

function toggleFacetContainer() {
  const facetContainerToggle = document
    .getElementById('facets-container-toggle');
  const facetsContainer = document.getElementById('facets-container');

  if (null === facetContainerToggle) {
    return;
  }

  facetContainerToggle.addEventListener('click', () => {
    const ariaExpanded = 'true' === facetContainerToggle
      .getAttribute('aria-expanded')
      ? 'false' : 'true';
    facetContainerToggle.setAttribute('aria-expanded', ariaExpanded);
    if (null !== facetContainerToggle) {
      facetsContainer.classList.toggle('slide-in');
    }
  });
}

window.addEventListener('DOMContentLoaded', () => {
  toggleFacets();
  showMoreFacets();
  toggleFacetContainer();
});

// Enable hot reloading
if (module.hot) {
  module.hot.accept();
}
